import { render, staticRenderFns } from "./SingleComplaint.vue?vue&type=template&id=16bede32&scoped=true&"
import script from "./SingleComplaint.vue?vue&type=script&lang=js&"
export * from "./SingleComplaint.vue?vue&type=script&lang=js&"
import style0 from "./SingleComplaint.vue?vue&type=style&index=0&id=16bede32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bede32",
  null
  
)

export default component.exports